import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "si-card flex-col" }
const _hoisted_2 = { class: "bold minor-title" }
const _hoisted_3 = { class: "form-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input = _resolveComponent("text-input")!
  const _component_date_input = _resolveComponent("date-input")!
  const _component_custom_field_input = _resolveComponent("custom-field-input")!
  const _component_ski_rental_input = _resolveComponent("ski-rental-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "Minor " + _toDisplayString(_ctx.index + 1), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_text_input, {
        label: 'First Name',
        modelValue: _ctx.minor.firstName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.minor.firstName) = $event)),
        showError: _ctx.invalidFirstName,
        onOnBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.invalidFirstName = $event)),
        altStyle: true,
        id: `minor-${_ctx.index + 1}-fistName`
      }, null, 8, ["modelValue", "showError", "id"]),
      _createVNode(_component_text_input, {
        label: 'Last Name',
        modelValue: _ctx.minor.lastName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.minor.lastName) = $event)),
        showError: _ctx.invalidLastName,
        onOnBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.invalidLastName = $event)),
        altStyle: true,
        id: `minor-${_ctx.index + 1}-lastName`
      }, null, 8, ["modelValue", "showError", "id"]),
      _createVNode(_component_date_input, {
        label: `Minor's birthday`,
        day: _ctx.minor.dateOfBirth.day,
        month: _ctx.minor.dateOfBirth.month,
        year: _ctx.minor.dateOfBirth.year,
        showError: _ctx.invalidBirthDate,
        onOnDateEntered: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDateEntered($event))),
        errorMsg: _ctx.minorDobErrorMsg,
        altStyle: true,
        numYears: _ctx.maxAge,
        id: `minor-${_ctx.index + 1}`
      }, null, 8, ["day", "month", "year", "showError", "errorMsg", "numYears", "id"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minor.customFields, (field, i) => {
        return (_openBlock(), _createBlock(_component_custom_field_input, {
          key: i,
          customField: field,
          ref_for: true,
          ref: `cf${i}`,
          altStyle: true,
          id: i
        }, null, 8, ["customField", "id"]))
      }), 128)),
      (_ctx.collectSkiRentalInfo)
        ? (_openBlock(), _createBlock(_component_ski_rental_input, {
            key: 0,
            label: 'Experience Level',
            responses: _ctx.skiRentalFields.experience,
            modelValue: _ctx.minor.skiExperienceKey,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.minor.skiExperienceKey) = $event)),
            showError: _ctx.skiRentalErrors.exp,
            onOnBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.skiRentalErrors.exp = $event)),
            altStyle: true
          }, null, 8, ["responses", "modelValue", "showError"]))
        : _createCommentVNode("", true),
      (_ctx.collectSkiRentalInfo)
        ? (_openBlock(), _createBlock(_component_ski_rental_input, {
            key: 1,
            label: 'Height',
            responses: _ctx.skiRentalFields.heights,
            modelValue: _ctx.minor.skiHeightKey,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.minor.skiHeightKey) = $event)),
            showError: _ctx.skiRentalErrors.height,
            onOnBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.skiRentalErrors.height = $event)),
            altStyle: true
          }, null, 8, ["responses", "modelValue", "showError"]))
        : _createCommentVNode("", true),
      (_ctx.collectSkiRentalInfo)
        ? (_openBlock(), _createBlock(_component_ski_rental_input, {
            key: 2,
            label: 'Weight',
            responses: _ctx.skiRentalFields.weights,
            modelValue: _ctx.minor.skiWeightKey,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.minor.skiWeightKey) = $event)),
            showError: _ctx.skiRentalErrors.weight,
            onOnBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.skiRentalErrors.weight = $event)),
            altStyle: true
          }, null, 8, ["responses", "modelValue", "showError"]))
        : _createCommentVNode("", true),
      (_ctx.collectSkiRentalInfo)
        ? (_openBlock(), _createBlock(_component_ski_rental_input, {
            key: 3,
            label: 'Shoe size',
            responses: _ctx.skiRentalFields.shoes,
            modelValue: _ctx.minor.skiShoeSizeKey,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.minor.skiShoeSizeKey) = $event)),
            showError: _ctx.skiRentalErrors.shoes,
            onOnBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.skiRentalErrors.shoes = $event)),
            altStyle: true
          }, null, 8, ["responses", "modelValue", "showError"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.minor.consentMinorKey)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "delete-minor-btn flex-row",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('removeMinor', _ctx.minor.guid)))
        }, _cache[14] || (_cache[14] = [
          _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-804cfd4c><line x1=\"4\" y1=\"7\" x2=\"20\" y2=\"7\" data-v-804cfd4c></line><line x1=\"10\" y1=\"11\" x2=\"10\" y2=\"17\" data-v-804cfd4c></line><line x1=\"14\" y1=\"11\" x2=\"14\" y2=\"17\" data-v-804cfd4c></line><path d=\"M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12\" data-v-804cfd4c></path><path d=\"M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3\" data-v-804cfd4c></path></svg><span data-v-804cfd4c>Remove minor</span>", 2)
        ])))
      : _createCommentVNode("", true)
  ]))
}